import {
	createSlice,
    PayloadAction,
} from '@reduxjs/toolkit';
import { RootState } from '../store';
import { ISellerInfo } from '@src/types/weddingHall';
export interface WeddingHallContractState {
	data: {
        hall:{
            hallName: string;
            hallImg:string;
            individualHallId:number|null;
            weddingDate:string;
            weddingTime: string;
            visitor:number;
            totalPrice:number;
            originPrice:number;
            salePrice:number;
        },
		user: {
            contractor:string;
            contractorTel:string;
            contractorEmail:string;
            contractorZipcode: string;
            contractorAddress1: string;
            contractorAddress2: string;
            brideName:string;
            brideTel: string
            groomName:string;
            groomTel:string;
		},
        agreement:{
            weddingContract: boolean; // 예식계약서 동의
            additionalInfo:boolean; // 추가사항 정보 확인 여부
            checkList: boolean; // 확인사항들 모두 체크 여부
            contractProduct: boolean; // 예식계약서 내 첫번째 체크박스
            contractRefund: boolean; // 예식계약서 내 두번째 체크박스
            personalPolicy: boolean; //개인정보제공 및 제3자 제공 동의
            finalAgree:boolean;
        },
        weddingContractData:{
            images: {title:string; url: string;}[]
            partnerName: string;
            individualHallName: string;
            individualHallId?:number | null;
            weddingDate: string;
            weddingTime:string;
            guarantee: number;
            discountRate: number;
            totalAmount: number;
            finalAmount: number;
            sellerInfo: ISellerInfo,
            regularPrice: {
              rentalFee: number;
              flowerFee: number;
              additionalProducts:{name: string; price: number; required:boolean;}[]
            },
            mealPrice: {
              adultFee: number;
              childFee: number;
              beverageFee: number;
              alcoholFee: number;
              giftFee: number;
            },
            totalPrice: {
              totalRentalFee: number;
              totalMealFee: number;
              saleRentalFee: number;
              saleMealFee: number;
            },
            additionalInformation:string;
            providedServices: { id:number; name:string;}[],
            files: {name:string;url: string;}[],
            deposit: number;
            availableContract: boolean;
            storedToConsulting: boolean;
            consultingUsed: boolean;
            shareLink: null | string;
            weddingDayId: number | null;
            term:string;
            agreement:string;
        }
	}
}

const initialState = {
	data: {
        hall:{
            hallName: '',
            hallImg:'',
            individualHallId:null,
            weddingDate:'',
            weddingTime:'',
            visitor:0,
            totalPrice:0,
            originPrice:0,
            salePrice:0,
        },
        user: {
            contractor:'',
            contractorTel:'',
            contractorEmail:'',
            contractorZipcode: '',
            contractorAddress1:'',
            contractorAddress2: '',
            brideName:'',
            brideTel: '',
            groomName:'',
            groomTel:''
		},
        agreement:{
            weddingContract: false, //예식계약서
            additionalInfo:false, //추가정보사항
            checkList:false, // 예식확인사항 이미지 체크 목록
            contractProduct: false, //대관료 동의
            contractRefund:false, // 약관 및 취소 동의
            personalPolicy: false, // 개인정보 수집 제공 동의
            finalAgree:false // 서명 및 동의
        },
        weddingContractData:{
            images: [],
            partnerName: "",
            individualHallName: "",
            individualHallId: null,
            weddingDate: "",
            weddingTime: "",
            guarantee: 0,
            discountRate: 0,
            totalAmount: 0,
            finalAmount: 0,
            sellerInfo: {
              partnerName: "",
              address: "",
              bizNumber: ""
            },
            regularPrice: {
              rentalFee: 0,
              flowerFee: 0,
              additionalProducts: [
                {
                  name: "",
                  price: 0,
                  required: false
                }
              ]
            },
            mealPrice: {
              adultFee: 0,
              childFee: 0,
              beverageFee: 0,
              alcoholFee: 0,
              giftFee: 0
            },
            totalPrice: {
              totalRentalFee: 0,
              totalMealFee: 0,
              saleRentalFee: 0,
              saleMealFee: 0
            },
            additionalInformation: "",
            providedServices: [],
            files: [],
            deposit: 0,
            availableContract: false,
            storedToConsulting: false,
            consultingUsed: false,
            shareLink: null,
            weddingDayId: null,
            term:'',
            agreement:''
        }
	}
} as WeddingHallContractState

const weddingHallContractSlice = createSlice({
	name: 'weddingHallContract',
	initialState,
	reducers: {
        setHallPriceInfo(state, action: PayloadAction<{data: any}>){
            state.data.hall = action.payload.data;
        },
        setUserInfo(state, action: PayloadAction<{data: any}>){
            state.data.user = {...state.data.user,...action.payload.data };
        },
        setAdressInfo(state, action: PayloadAction<{zipcode: string,roadAddress:string,detailAddress:string}>){
            state.data.user.contractorZipcode = action.payload.zipcode;
            state.data.user.contractorAddress1 = action.payload.roadAddress;
            state.data.user.contractorAddress2 = action.payload.detailAddress || '';
        },
        setAgreement(state, action: PayloadAction<{keyname:string, checked:boolean}>){
            const { keyname, checked } = action.payload;
            state.data.agreement[keyname] = checked;

            if(keyname === 'weddingContract' && checked === false){
                state.data.agreement.weddingContract = false;
                state.data.agreement.contractProduct = false
                state.data.agreement.contractRefund = false
                state.data.agreement.additionalInfo = false
                state.data.agreement.checkList = false
                state.data.agreement.finalAgree = false
            }
            if(state.data.agreement.contractProduct && state.data.agreement.contractRefund
                && state.data.agreement.additionalInfo && state.data.agreement.checkList && state.data.agreement.finalAgree){
                state.data.agreement.weddingContract = true;
            }else{
                state.data.agreement.weddingContract = false;
            }
        },
        setWeddingContractData(state, action: PayloadAction<{data: any}>){
            state.data.weddingContractData = action.payload.data;
        }
	},
});


export const {setHallPriceInfo, setUserInfo,setAdressInfo,setAgreement,setWeddingContractData} = weddingHallContractSlice.actions;
export const weddingHallContract = (state: RootState) => state.weddingHallContract;
export default weddingHallContractSlice.reducer;

